module.exports = __webpack_public_path__ + "brandon_bld_it-webfont.e3ccb154cd1f2cf94150.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/brandon_bld_it-webfont.woff2
// module id = 934
// module chunks = 7